import {createRef, subtractDays} from "./functions";

export function headModel() {
    return {
        client: {
            require: true,
            regexp: /^\d+$/,
            value: '',
            ref: createRef()
        },
        date_postavka: {
            require: false,
            regexp: null,
            value: ''
        },
        marking: {
            require: false,
            regexp: null,
            value: ''
        },
        exporter: {
            require: true,
            value: [],
            regexp: null,
            ref: createRef()
        },
        // byorder: {
        //     require: false,
        //     value: [],
        //     regexp: null
        // },
        importer: {
            require: true,
            value: [],
            regexp: null,
            ref: createRef()
        },
        transp_num: {
            require: true,
            regexp: /^[\w\/-]{3,}$/,
            value: '',
            ref: createRef()
        },
        preinfo_num: {
            require: false,
            regexp: null,
            value: '',
            ref: createRef(),
        },
        preinfo_state: {
            require: false,
            regexp: null,
            value: '',
            ref: createRef()
        }
        // tir: {
        //     require: false,
        //     regexp: null,
        //     value: ''
        // },
        // cmr: {
        //     require: false,
        //     regexp: null,
        //     value: ''
        // },
        // invoice: {
        //     require: false,
        //     regexp: null,
        //     value: ''
        // },
        // hologram: {
        //     require: false,
        //     regexp: /^[\w\s()\/-]+$/,
        //     value: '',
        //     ref: createRef()
        // }
    };
}

export function fssProductPattern() {
    return {
        id: null,
        production: {
            value: {
                id: null,
                    name: ''
            },
            require: true,
                regexp: null,
                ref: createRef()
        },
        netto:  {
            value: '',
                require: true,
                regexp: null,
                ref: createRef()
        },
        unit:  {
            value: '',
                require: true,
                regexp: null,
                ref: createRef()
        }
    };
}

export function fssPattern() {
    return {
        id: null,
        country: {
            value: {
                id: null,
                name: ''
            },
            require: true,
            regexp: null,
            ref: createRef()
        },
        file: {
            exist: null,
            name: '',
            type: '',
            value: '',
            require: true,
            regexp: null,
            ref: createRef()
        },
        date: {
            value: '',
            require: true,
            regexp: null,
            ref: createRef()
        },
        num: {
            value: '',
            require: true,
            regexp: /^[\w\s.()\/-]{3,}$/,
            ref: createRef(),
            valid: {
                ref: createRef(),
                info: ''
            }
        },
        exporter: {
            value: '',
            require: true,
            regexp: /^[\w\s().,\/`&-]+$/,
            ref: createRef()
        },
        importer: {
            value: '',
            require: true,
            regexp: /^[\w\s().,\/`&-]+$/,
            ref: createRef()
        },
        product: [fssProductPattern()]
    }
}

export function reExportProductPattern() {
    return {
        id: null,
        production: {
            value: {
                id: null,
                name: ''
            },
            require: true,
            regexp: null,
            ref: createRef()
        },
        netto: {
            value: '',
            require: true,
            regexp: null,
            ref: createRef()
        },
        unit: {
            value: '',
            require: true,
            regexp: /^\d+$/,
            ref: createRef()
        },
        country: {
            value: {
                id: null,
                name: ''
            },
            require: true,
            regexp: null,
            ref: createRef()
        }
    }
}

export function reExportPattern() {
    return {
        id: null,
        kodfito: {
            value: '',
            require: true,
            regexp: /^\d+$/,
            ref: createRef()
        },
        num: {
            value: '',
            require: true,
            regexp: /^[\w\/-]{4,}$/,
            ref: createRef()
        },
        date: {
            value: '',
            require: true,
            regexp: null,
            ref: createRef()
        },
        product: [reExportProductPattern()]
    }
}

export function filePattern() {
    return {
        exist: null,
        name: '',
        type: '',
        value: '',
        ref: createRef()
    }
}